import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

export type ChangeReasonModalProps = {
  isOpen: boolean;
  onClose: () => void;
  /** Called with the trimmed reason string when the user confirms. */
  onConfirm: (reason: string) => void;
  /** Show a spinner on the Confirm button while the parent is saving. */
  isLoading?: boolean;
  title?: string;
};

const ChangeReasonModal: React.FC<ChangeReasonModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title = "Reason for Change",
}) => {
  const [reason, setReason] = useState("");
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setReason("");
      setTouched(false);
    }
  }, [isOpen]);

  const trimmed = reason.trim();
  const isInvalid = touched && !trimmed;

  const handleConfirm = () => {
    setTouched(true);
    if (!trimmed) return;
    onConfirm(trimmed);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="16px">
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isRequired isInvalid={isInvalid}>
            <FormLabel>Please provide a reason for this change</FormLabel>
            <Textarea
              placeholder="Enter reason…"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (!touched) setTouched(true);
              }}
              rows={3}
              bg="#F8F9FA"
              borderRadius="12px"
              borderColor="rgba(108,117,125,0.3)"
            />
            {isInvalid && (
              <FormErrorMessage>Reason is mandatory.</FormErrorMessage>
            )}
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <Button variant="outline" onClick={onClose} isDisabled={isLoading}>
              Cancel
            </Button>
            <Button
              bg="#4A2C2A"
              color="white"
              _hover={{ bg: "#3a201f" }}
              onClick={handleConfirm}
              isLoading={isLoading}
              isDisabled={!trimmed}
            >
              Confirm
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ChangeReasonModal;
